
import { defineComponent, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useI18n } from 'vue-i18n'

import { axios } from '@/plugins/axios'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import { nextQueryKeys } from '@/utils/router'
import { HOME_PATH } from '@/router/routes'

export default defineComponent({
  components: { BaseFormSubmit },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const { t } = useI18n()

    const btnDisabled = ref(false)

    const schema = yup.object({
      email: yup.string().required().email().max(255),
      password: yup.string().required().max(255),
      remember: yup.boolean(),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema })

    const { value: email } = useField<string>('email')
    const { value: password } = useField<string>('password')
    const { value: remember } = useField<boolean>('remember')

    const onSubmit = handleSubmit(values => {
      const nextQuery = route.query[nextQueryKeys[0]] as string
      const nextPath = nextQuery ? nextQuery : HOME_PATH
      btnDisabled.value = true
      axios
        .post('/login', values)
        .then(() => {
          router.push(nextPath)
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      email,
      password,
      remember,
      onSubmit,
      btnDisabled,
    }
  },
})
